/**
 * Dummy function that does nothing
 */
export function voidFunc(): void {
  return;
}
